import React, { Component } from "react";
import styled, { css } from "styled-components";

import ReactAux from "../../hoc/ReactAux/ReactAux";

const H1 = styled.h1`
  font-size: 3rem;
  color: #012639;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

const H2 = styled.h2`
  font-size: 1.5rem;
  color: #012639;
  margin-bottom: 0.5rem;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
    ${props =>
    props.lato &&
    css`
      font-family: "Lato", sans-serif;
    `}
`;

class Title extends Component {
  render() {
    return (
      <ReactAux>
        <H1 poppins>The Year 2038 Problem</H1>
        <H2 lato>How long until the end of the world?</H2>
      </ReactAux>
    );
  }
}

export default Title;
